/* eslint-disable camelcase */
export interface IUpdateStageDTO {
  name?: string;
  description?: string;
  state?: string;
  progress?: number;
  start_date?: string;
  end_date?: string;
}

export default class UpdateStageDTO {
  public name?: string;

  public state?: string;

  public progress?: number;

  public description?: string;

  public start_date?: string;

  public end_date?: string;

  constructor(data: IUpdateStageDTO) {
    this.name = data.name;
    this.state = data.state;
    this.progress = data.progress;
    this.description = data.description;
    this.start_date = data.start_date;
    this.end_date = data.end_date;
  }
}
